module.exports = __webpack_public_path__ + "img/pinpaijingying.405a6797.png";